export default __webpack_public_path__ + "static/media/ic_product_vorsorge-gold.5b1151e2.svg";